import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import "./navbar.css";

/* ─────────────────────────────────────────
   NAV DATA
   href  → internal route   ("/about")
   hash  → section id       ("#web")
   tab   → careers tab key  ("fulltime" | "internship" | "courses")
───────────────────────────────────────── */
interface MegaItem {
  label: string;
  desc?: string;
  href: string;        // page route
  hash?: string;       // scroll target id
  tab?: string;        // careers tab
}
interface MegaColumn { heading: string; items: MegaItem[] }
interface NavItem     { label: string; href?: string; mega?: MegaColumn[] }

const NAV_ITEMS: NavItem[] = [
  {
    label: "What We Do",
    mega: [
      {
        heading: "Capabilities",
        // items: [
        //   { label: "Web Development",      desc: "React, Next.js, Node.js",   href: "/about", hash: "web"       },
        //   { label: "Mobile App Dev",        desc: "React Native & Flutter",    href: "/about", hash: "mobile"    },
        //   { label: "AI & Machine Learning", desc: "Intelligent automation",    href: "/about", hash: "ai"        },
        //   { label: "Cloud & DevOps",        desc: "AWS, Docker, Kubernetes",   href: "/about", hash: "cloud"     },
        //   { label: "Cyber Security",        desc: "VAPT, Ethical Hacking",     href: "/about", hash: "security"  },
        //   { label: "UI/UX Design",          desc: "Figma-first design systems", href: "/about", hash: "design"   },
        // ],
        items: [
          { label: "Web Development",         href: "/what-we-do", hash: "Who We Are"       },
          { label: "Mobile App Dev",            href: "/what-we-do", hash: "mobile"    },
          { label: "AI & Machine Learning",     href: "/what-we-do", hash: "ai"        },
          { label: "Cloud & DevOps",           href: "/what-we-do", hash: "cloud"     },
          { label: "Cyber Security",            href: "/what-we-do", hash: "security"  },
          { label: "UI/UX Design",           href: "/what-we-do", hash: "design"   },
        ],
      },
      {
        heading: "Industries",
        items: [
          { label: "Healthcare",              href: "/what-we-do", hash: "health"    },
          { label: "Banking & Finance",       href: "/what-we-do", hash: "finance"   },
          { label: "Retail & E-Commerce",     href: "/what-we-do", hash: "retail"    },
          { label: "Education & EdTech",      href: "/what-we-do", hash: "edu"       },
          { label: "Logistics & Supply Chain",href: "/what-we-do", hash: "logistics" },
          { label: "Real Estate",             href: "/what-we-do", hash: "realestate"},
        ],
      },
      {
        heading: "Solutions",
        items: [
          { label: "Digital Transformation", href: "/what-we-do", hash: "digital"    },
          { label: "Product Engineering",    href: "/what-we-do", hash: "product"    },
          { label: "IT Consulting",          href: "/what-we-do", hash: "consulting" },
          { label: "Digital Marketing",      href: "/what-we-do", hash: "marketing"  },
        ],
      },
    ],
  },
  {
    label: "Who We Are",
    mega: [
      {
        heading: "Company",
        items: [
          { label: "About AJERA",         desc: "Our story and mission",        href: "/about"              },
          { label: "Leadership Team",     desc: "Meet the people leading us",   href: "/about", hash: "team"   },
          { label: "Our Values",          desc: "What drives us every day",     href: "/about", hash: "values" },
          // { label: "Awards & Recognition",                                       href: "/about", hash: "awards" },
        ],
      },
      {
        heading: "Community",
        items: [
          { label: "Blog & Insights", href: "/about", hash: "blog"     },
          { label: "Case Studies",    href: "/about", hash: "cases"    },
          { label: "Newsroom",        href: "/about", hash: "news"     },
          // { label: "Partners",        href: "/about", hash: "partners" },
        ],
      },
    ],
  },
  {
    label: "Careers",
    mega: [
      {
        heading: "Full Time Jobs",
        // items: [
        //   { label: "Full Stack Developer",    desc: "2–4 Yrs · Chennai/Remote", href: "/careers", tab: "fulltime"   },
        //   { label: "AI / ML Engineer",        desc: "3–5 Yrs · Chennai",        href: "/careers", tab: "fulltime"   },
        //   { label: "DevOps Engineer",         desc: "2–3 Yrs · Remote",         href: "/careers", tab: "fulltime"   },
        //   { label: "UI/UX Designer",          desc: "1–3 Yrs · Chennai",        href: "/careers", tab: "fulltime"   },
        //   { label: "Cyber Security Analyst",  desc: "2–5 Yrs · Chennai",        href: "/careers", tab: "fulltime"   },
        // ],
        items: [
          { label: "Full Stack Developer Trainee",     href: "/careers", tab: "fulltime"   },
          { label: "AI / ML Engineer Trainee",              href: "/careers", tab: "fulltime"   },
          { label: "Application Developer Trainee",                href: "/careers", tab: "fulltime"   },
          { label: "Trainer",                  href: "/careers", tab: "fulltime"   },
          // { label: "Cyber Security Analyst",          href: "/careers", tab: "fulltime"   },
        ],
      },
      {
        heading: "Internship",
        // items: [
        //   { label: "Frontend Dev Intern",  desc: "3–6 Months · ₹8K–12K/mo",  href: "/careers", tab: "internship" },
        //   { label: "Backend Dev Intern",   desc: "3–6 Months · ₹8K–12K/mo",  href: "/careers", tab: "internship" },
        //   { label: "AI/ML Intern",         desc: "3–6 Months · ₹10K–15K/mo", href: "/careers", tab: "internship" },
        //   { label: "UI/UX Design Intern",  desc: "2–4 Months · ₹6K–10K/mo",  href: "/careers", tab: "internship" },
        // ],
        items: [
          { label: "Frontend Dev Intern",    href: "/careers", tab: "internship" },
          { label: "Backend Dev Intern",     href: "/careers", tab: "internship" },
          { label: "AI/ML Intern",          href: "/careers", tab: "internship" },
          { label: "UI/UX Design Intern",    href: "/careers", tab: "internship" },
          { label: "Digital Marketing Intern",    href: "/careers", tab: "internship" },
          { label: "Mobile App Dev Intern",    href: "/careers", tab: "internship" },
        ],
      },
      {
        heading: "Courses",
        // items: [
        //   { label: "Full Stack Development",    desc: "5 Months · ₹18,000", href: "/careers", tab: "courses" },
        //   { label: "AI / Machine Learning",     desc: "4 Months · ₹15,000", href: "/careers", tab: "courses" },
        //   { label: "AWS Cloud & DevOps",        desc: "4 Months · ₹18,000", href: "/careers", tab: "courses" },
        //   { label: "Cyber Security",            desc: "4 Months · ₹16,000", href: "/careers", tab: "courses" },
        //   { label: "View All 11 Courses →",                                  href: "/careers", tab: "courses" },
        // ],
        items: [
          { label: "Full Stack Development",     href: "/careers", tab: "courses" },
          { label: "AI / Machine Learning",      href: "/careers", tab: "courses" },
          { label: "AWS Cloud & DevOps",         href: "/careers", tab: "courses" },
          { label: "Cyber Security",             href: "/careers", tab: "courses" },
          { label: "View All 11 Courses →",      href: "/careers", tab: "courses" },
        ],
      },
    ],
  },
];

/* ─────────────────────────────────────────
   SMOOTH SCROLL HELPER
   Waits for route navigation then scrolls
───────────────────────────────────────── */
function scrollToHash(hash: string) {
  const attempt = (tries: number) => {
    const el = document.getElementById(hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (tries > 0) {
      setTimeout(() => attempt(tries - 1), 120);
    }
  };
  attempt(10);
}

/* ─────────────────────────────────────────
   CAREERS TAB EVENT
   Careers page listens for this custom event
───────────────────────────────────────── */
function emitCareersTab(tab: string) {
  window.dispatchEvent(new CustomEvent("ajera:careers-tab", { detail: tab }));
}

/* ═════════════════════════════════════════
   NAVBAR COMPONENT
═════════════════════════════════════════ */
const Navbar: React.FC = () => {
  const [activeMenu, setActiveMenu]       = useState<string | null>(null);
  const [scrolled, setScrolled]           = useState(false);
  const [mobileOpen, setMobileOpen]       = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState<string | null>(null);

  /* Blue underline state */
  const [underline, setUnderline] = useState({ left: 0, width: 0, visible: false });
  const linksRef  = useRef<HTMLUListElement>(null);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const navRef    = useRef<HTMLElement>(null);

  const location = useLocation();
  const navigate = useNavigate();

  /* scroll → solid bar */
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  /* close everything on route change */
  useEffect(() => {
    setMobileOpen(false);
    setActiveMenu(null);
    setUnderline(u => ({ ...u, visible: false }));
  }, [location]);

  /* outside click closes mega */
  useEffect(() => {
    const fn = (e: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(e.target as Node)) {
        setActiveMenu(null);
        setUnderline(u => ({ ...u, visible: false }));
      }
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  /* ── Underline helpers ── */
  const showUnderline = (el: HTMLElement) => {
    if (!linksRef.current) return;
    const listRect = linksRef.current.getBoundingClientRect();
    const itemRect = el.getBoundingClientRect();
    setUnderline({ left: itemRect.left - listRect.left, width: itemRect.width, visible: true });
  };

  const handleItemEnter = (label: string, el: HTMLElement) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    if (NAV_ITEMS.find(i => i.label === label)?.mega) setActiveMenu(label);
    showUnderline(el);
  };

  const handleItemLeave = () => {
    closeTimer.current = setTimeout(() => {
      setActiveMenu(null);
      setUnderline(u => ({ ...u, visible: false }));
    }, 140);
  };

  const handleDropEnter = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
  };

  /* ── Navigate to item (handles hash + tab) ── */
  const goTo = (item: MegaItem) => {
    setActiveMenu(null);
    setMobileOpen(false);
    setUnderline(u => ({ ...u, visible: false }));

    const isAlreadyOnPage = location.pathname === item.href;

    if (item.tab) {
      /* Careers tab */
      if (isAlreadyOnPage) {
        emitCareersTab(item.tab);
      } else {
        sessionStorage.setItem("ajera:careers-tab", item.tab);
        navigate(item.href);
      }
      return;
    }

    if (item.hash) {
      /* Section scroll */
      if (isAlreadyOnPage) {
        scrollToHash(item.hash);
      } else {
        sessionStorage.setItem("ajera:scroll-hash", item.hash);
        navigate(item.href);
      }
      return;
    }

    /* Plain page link */
    navigate(item.href);
  };

  /* ── After navigation: consume stored intent ── */
  useEffect(() => {
    const hash = sessionStorage.getItem("ajera:scroll-hash");
    const tab  = sessionStorage.getItem("ajera:careers-tab");

    if (hash) {
      sessionStorage.removeItem("ajera:scroll-hash");
      scrollToHash(hash);
    }
    if (tab) {
      sessionStorage.removeItem("ajera:careers-tab");
      setTimeout(() => emitCareersTab(tab), 80);
    }
  }, [location.pathname]);

  /* ══════════════════════════════════════ */
  return (
    <nav
      ref={navRef}
      className={`navbar ${scrolled ? "navbar--scrolled" : ""} ${mobileOpen ? "navbar--mobile-open" : ""}`}
    >
      {/* ── BAR ── */}
      <div className="navbar__bar">
        {/* LOGO */}
<Link to="/" className="navbar__logo">
  
<img 
  // src="/ajera_logo.svg" 
  src="/9 - Copy.png" 
  alt="AJERA Logo" 
  className="navbar__logo-img"
/>
</Link>

        {/* DESKTOP LINKS */}
        <ul className="navbar__links" ref={linksRef}>
          {NAV_ITEMS.map((item) => (
            <li
              key={item.label}
              className={`navbar__item ${activeMenu === item.label ? "navbar__item--active" : ""}`}
              onMouseEnter={e => handleItemEnter(item.label, e.currentTarget)}
              onMouseLeave={handleItemLeave}
            >
              <button
                className="navbar__link navbar__link--btn"
                onClick={() => item.href && navigate(item.href)}
              >
                {item.label}
                {item.mega && (
                  <ChevronDown
                    size={14}
                    className={`navbar__chevron ${activeMenu === item.label ? "navbar__chevron--up" : ""}`}
                  />
                )}
              </button>
            </li>
          ))}

          {/* <li
            className="navbar__item"
            onMouseEnter={e => { if (closeTimer.current) clearTimeout(closeTimer.current); showUnderline(e.currentTarget); }}
            onMouseLeave={handleItemLeave}
          >
            <Link to="/about" className="navbar__link">About</Link>
          </li> */}

          {/* ── BLUE UNDERLINE SLIDER ── */}
          <div
            className="navbar__underline"
            style={{
              left:    underline.left,
              width:   underline.width,
              opacity: underline.visible ? 1 : 0,
            }}
          />
        </ul>

        {/* CTA + BURGER */}
        <div className="navbar__actions">
          <Link to="/contact" className="navbar__cta">Contact Us</Link>
          <button
            className={`navbar__burger ${mobileOpen ? "navbar__burger--open" : ""}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* ── MEGA MENU ── */}
      {NAV_ITEMS.filter(i => i.mega).map(item =>
        activeMenu === item.label ? (
          <div
            key={item.label}
            className="navbar__mega"
            onMouseEnter={handleDropEnter}
            onMouseLeave={handleItemLeave}
          >
            <div className="navbar__mega-inner">
              {/* Left accent heading */}
              <div className="navbar__mega-title-col">
                <p className="navbar__mega-big-title">{item.label}</p>
                <p className="navbar__mega-big-sub">
                  {item.label === "What We Do"  && "Services & expertise we deliver"}
                  {item.label === "Who We Are"  && "Our story, team and values"}
                  {item.label === "Careers"     && "Join us · Learn with us"}
                </p>
                <div className="navbar__mega-arrow">→</div>
              </div>

              {/* Columns */}
              {item.mega!.map((col, ci) => (
                <div key={col.heading} className="navbar__mega-col">
                  <p className="navbar__mega-heading">{col.heading}</p>
                  {col.items.map(row => (
                    <button
                      key={row.label}
                      className="navbar__mega-item"
                      onClick={() => goTo(row)}
                    >
                      <span className="navbar__mega-item-label">{row.label}</span>
                      {row.desc && (
                        <span className="navbar__mega-item-desc">{row.desc}</span>
                      )}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ) : null
      )}

      {/* ── MOBILE MENU ── */}
      <div className={`navbar__mobile ${mobileOpen ? "navbar__mobile--open" : ""}`}>
        {NAV_ITEMS.map(item => (
          <div key={item.label} className="navbar__mob-group">
            <button
              className="navbar__mob-toggle"
              onClick={() => setMobileExpanded(mobileExpanded === item.label ? null : item.label)}
            >
              {item.label}
              <ChevronDown
                size={14}
                className={`navbar__chevron ${mobileExpanded === item.label ? "navbar__chevron--up" : ""}`}
              />
            </button>

            {mobileExpanded === item.label && item.mega && (
              <div className="navbar__mob-dropdown">
                {item.mega.map(col => (
                  <div key={col.heading} className="navbar__mob-col">
                    <p className="navbar__mob-col-heading">{col.heading}</p>
                    {col.items.map(row => (
                      <button
                        key={row.label}
                        className="navbar__mob-link"
                        onClick={() => goTo(row)}
                      >
                        {row.label}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        {/* <Link
          to="/about"
          className="navbar__mob-link navbar__mob-link--plain"
          onClick={() => setMobileOpen(false)}
        >
          About
        </Link> */}
        <Link
          to="/contact"
          className="navbar__cta navbar__mob-cta"
          onClick={() => setMobileOpen(false)}
        >
          Contact Us
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
